import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CONFIGS = {
  assaggi: {
    tag: "Guida gratuita",
    headline: "ASSAGGI D'ARTE",
    sub: "Inserisci la tua email e ricevi gratis la guida completa alle serate 2026.",
    endpoint: "/leads/assaggi-arte",
    note: "Nessuno spam. Solo aggiornamenti sulle serate Wildersquad.",
  },
  jr: {
    tag: "Guida gratuita",
    headline: "Wild Chef Jr. — Guida Gratuita",
    sub: "Inserisci la tua email e ricevi gratis la guida con ricetta esclusiva e anteprima del corso di cucina per famiglie.",
    endpoint: "/leads/corso-bambini",
    note: "Nessuno spam. Solo aggiornamenti sui corsi Wildersquad.",
  },
};

export default function OptinGuida({ variant }) {
  const cfg = CONFIGS[variant];
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!nome.trim() || !email.trim()) return;
    setSending(true);
    try {
      await axios.post(`${API}${cfg.endpoint}`, { nome: nome.trim(), email: email.trim() });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nell'invio, riprova.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-5 py-16" data-testid={`optin-page-${variant}`}>
      <div className="w-full max-w-md">
        <p className="text-[#c4704b] uppercase tracking-[0.3em] text-[11px] font-bold mb-6 text-center">
          Wildersquad · {cfg.tag}
        </p>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-[#f5f0e8] text-center leading-tight mb-5">
          {cfg.headline}
        </h1>
        <p className="text-[#c9c4b8] text-sm sm:text-base leading-relaxed text-center mb-10">
          {cfg.sub}
        </p>

        {done ? (
          <div className="border border-[#c4704b] bg-[#c4704b]/10 px-6 py-8 text-center" data-testid="optin-success-message">
            <p className="text-[#f5f0e8] text-lg font-bold leading-relaxed">
              ✅ Perfetto! Controlla la tua email — la guida è in arrivo.
            </p>
            <p className="text-[#c9c4b8] text-sm mt-3">Se non la vedi entro qualche minuto, controlla la cartella spam.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="optin-form">
            <input
              type="text" required minLength={2} maxLength={80} value={nome}
              onChange={(e) => setNome(e.target.value)} placeholder="Il tuo nome"
              data-testid="optin-nome-input"
              className="w-full bg-[#111] border border-[#333] focus:border-[#c4704b] outline-none px-4 py-3.5 text-[#f5f0e8] placeholder-[#777] text-base transition-colors"
            />
            <input
              type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="La tua email"
              data-testid="optin-email-input"
              className="w-full bg-[#111] border border-[#333] focus:border-[#c4704b] outline-none px-4 py-3.5 text-[#f5f0e8] placeholder-[#777] text-base transition-colors"
            />
            <button
              type="submit" disabled={sending} data-testid="optin-submit-btn"
              className="w-full bg-[#c4704b] hover:bg-[#a85c3c] disabled:opacity-60 text-white font-black uppercase tracking-[0.12em] text-sm px-6 py-4 transition-colors"
            >
              {sending ? "Invio in corso…" : "INVIA LA GUIDA GRATUITA →"}
            </button>
            <p className="text-[#8a8578] text-xs text-center pt-1">{cfg.note}</p>
          </form>
        )}
      </div>
    </div>
  );
}
